export default function Intro() {
    return (
        <div
            className="intro md:mt-[auto] md:pb-0 relative min-h-[calc(100vh-150px)] md:min-h-[calc(100vh-180px)] bg-cover bg-right lg:bg-top bg-no-repeat bg-opacity-50 flex items-center"
            style={{ backgroundImage: "url('/bg.svg')" }}
        >
            <div className="max-w-[1440px] mx-auto px-[20px] py-[40px] w-full flex items-center">
                <div className="flex flex-col gap-6 lg:max-w-[50%]">
                    <h1 className="text-4xl lg:text-5xl font-normal flex gap-6 w-full !leading-[120%] text-white">
                        <div className="shrink-0 h-[40px] md:h-[50px]">
                            <img
                                className="w-full h-full object-contain"
                                src="hello.png"
                                alt="hello"
                            />
                        </div>
                        Hi! My name is Mariia. <br></br>I am a Web Developer
                        based in Ukraine
                    </h1>
                    <a
                        href="/CV_Updated.pdf"
                        download
                        className="h-[45px] font-medium flex items-center justify-center bg-white rounded-lg text-black w-full sm:w-[240px] py-[10px] sm:py-[15px] px-4 sm:ml-[70px] mt-[80px]"
                    >
                        Download CV
                    </a>
                </div>

                <div className="hidden md:block w-full max-w-[500px] mx-auto relative overflow-hidden">
                    {/* <img
                        src="profile-2.png"
                        alt="Mariia's profile"
                        className="w-full h-full object-cover rounded-lg"
                    /> */}
                    <div className="absolute bottom-0 left-0 right-0">
                        <svg
                            width="742"
                            height="121"
                            viewBox="0 0 742 121"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <rect
                                width="743"
                                height="121"
                                fill="url(#paint0_linear_1063_66)"
                            />
                            <defs>
                                <linearGradient
                                    id="paint0_linear_1063_66"
                                    x1="359.366"
                                    y1="121"
                                    x2="357.358"
                                    y2="0.0290583"
                                    gradientUnits="userSpaceOnUse"
                                >
                                    <stop stop-color="#161511" />
                                    <stop
                                        offset="1"
                                        stop-color="#161511"
                                        stop-opacity="0"
                                    />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}
